import { PropsWithChildren } from 'react';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  footnote?: string;
  loading?: boolean;
}

const ChartCard = ({ title, subtitle, footnote, loading, children }: PropsWithChildren<ChartCardProps>) => (
  <article className={`chart-card ${loading ? 'is-loading' : ''}`}>
    <div className="chart-card__header">
      <div>
        <h2>{title}</h2>
        {subtitle && <p className="subtitle">{subtitle}</p>}
        {footnote && (
          <p className="footnote chart-card__footnote" style={{ marginTop: '4px' }}>
            {footnote}
          </p>
        )}
      </div>
    </div>
    <div className="chart-card__body">
      {loading && (
        <div className="chart-card__loader">
          <div className="spinner" />
        </div>
      )}
      <div className={loading ? 'chart-content-hidden' : ''}>
        {children}
      </div>
    </div>
  </article>
);

export default ChartCard;
